module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.brandSheet.id) ? _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "fullscreen": "",
      "transition": "fade-transition"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "brand-fact-sheet-view-card",
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('v-toolbar', {
    staticClass: "mb-12",
    attrs: {
      "color": "secondary",
      "elevate-on-scroll": ""
    }
  }, [(_vm.isStoryTell) ? _c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Brand Fact Sheet - " + _vm._s(_vm.brandSheet.clientName))]) : _vm._e(), _vm._v(" "), (_vm.isUGC) ? _c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Brand Fact Sheet - " + _vm._s(_vm.brandSheet.campaignName))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.brandSheet.type) ? _c('v-container', {
    staticClass: "ims-modal-body brand-fact-sheet-view-body",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "feedbackform",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.isStoryTell) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("STORYTELL - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/brand_sheet/storytell_bg.jpg"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionOne.title))])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionOne.subtitle))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    })])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionTwo.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionTwo.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    })])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionThree.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionThree.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.type === 'textbox' || field.type === 'textarea' || field.type === 'select') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'checkbox') ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [(_vm.brandSheet[field.name].length === 0) ? _c('p', [_vm._v("-")]) : _vm._e(), _vm._v(" "), _vm._l((field.detailFields.filter(function (v) { return _vm.brandSheet[field.name].includes(v.value); })), function(age) {
      return _c('v-flex', {
        key: age.key,
        attrs: {
          "xs12": "",
          "md12": ""
        }
      }, [_c('p', [_vm._v(_vm._s(age.label))])])
    })], 2) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', [(_vm.brandSheet[field.name].length > 0) ? _c('v-row', _vm._l((_vm.brandSheet[field.name]), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('image') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        staticClass: "grey lighten-2",
        attrs: {
          "width": "67",
          "height": "85",
          "src": item.url,
          "lazy-src": item.url,
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e()])
    }), 1) : _vm._e()], 1) : _vm._e()], 1)])
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isAOK) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("KOBE Uncut - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetAOKFormSections.sectionOne.title))])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetAOKFormSections.sectionOne.subtitle))])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/brand_sheet/aok_bg.png"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LEAD TIME")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("14 days upon receiving this brand fact sheet and logistics from the client.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("SELECTION CRITERIA")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Profiles proposed will be screened for audience credibility on KOBE Patented Influencer Management System (IMS)")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("For niche requirements (for example, ethnicity, professions) , please opt for storytell packages instead.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CAMPAIGN INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LOGISTICS ARRANGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("It is recommended for our clients to make your own logistics arrangements.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("There will be a 5 working day turnaround for all logistics arrangements.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will not be responsible for any damaged or lost parcels.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("ADDITIONAL ENGAGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Kindly note that any additional engagements listed here are not applicable for KOBE Uncut campaigns and you could opt for Storytell campaign and are chargeable, kindly ensure that requirements are stated clearly with your Client Engagement Representative before launching of the campaign:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("● Contest giveaway on social media ● Photoshoot for client ● Video appearance in client’s own production ● Usage of photos/videos from creators as Ads online or offline ● Promo Code Shoutout ● Link in Bio/Swipe Up")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetAOKFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.type !== 'file') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'file' && _vm.brandSheet[field.name].length > 0) ? _c('div', [_c('v-row', _vm._l((_vm.brandSheet[field.name]), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('image') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        staticClass: "grey lighten-2",
        attrs: {
          "width": "67",
          "height": "85",
          "src": item.url,
          "lazy-src": item.url,
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e()])
    }), 1)], 1) : _vm._e()])])
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isKobeLite) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("KOBE Lite - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetKobeLiteFormSections.sectionOne.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LEAD TIME")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("14 days upon receiving this brand fact sheet and logistics from the client.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CAMPAIGN INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetKobeLiteFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.type !== 'file') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'file' && _vm.brandSheet[field.name].length > 0) ? _c('div', [_c('v-row', _vm._l((_vm.brandSheet[field.name]), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('image') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        staticClass: "grey lighten-2",
        attrs: {
          "width": "67",
          "height": "85",
          "src": item.url,
          "lazy-src": item.url,
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e()])
    }), 1)], 1) : _vm._e()])])
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isUGC) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("UGC (User-Generated-Content) Videos Application Form")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h5 font-weight-bold mb-0"
  }, [_vm._v("I am aware that kobe’s full service of S$15k and up, includes:")]), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("Marketing goal, objective, and influence strategy consultation, incorporating the availability heuristic, bandwagon effect, and clustering effect for cognitive and emotive influence.")]), _vm._v(" "), _c('li', [_vm._v("Development of social media content concepts and strategies using 7X award-winning A.U.D.I framework.")]), _vm._v(" "), _c('li', [_vm._v("Curated creator identification through patented proprietary software, unveiling deep insights into social performance, audience demographics, and creator interest and personality profiling.")]), _vm._v(" "), _c('li', [_vm._v("Comprehensive creator relationship management services, including content curation, quality assurance, vetting and scheduling.")]), _vm._v(" "), _c('li', [_vm._v("Tailored content direction and brief design aligned with marketing objectives, encompassing recommendations for hashtags, captions, content direction, platform selection, optimal timing, and social SEO optimization.")]), _vm._v(" "), _c('li', [_vm._v("Up to 3 accesses to our Influencer Management System® to streamline influencer campaign management.")]), _vm._v(" "), _c('li', [_vm._v("Access to dedicated account managers, strategy planners, and community curators, providing expert recommendations and support.")])])]), _vm._v(" "), _c('p', [_vm._v("Lead time: 4 weeks")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("To proceed with UGC videos application, please complete the following.")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.brandSheet.ugcVideo) + "\n              ")]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_c('strong', [_vm._v("Includes:")])]), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("Utilization and exposure to a nano-reviewer base of 10,000 individuals with follower counts up to 3,000.")]), _vm._v(" "), _c('li', [_vm._v("Guidance and assistance in the creation of email invitations for reviewer outreach and engagement.")]), _vm._v(" "), _c('li', [_vm._v("Immediate notifications when content is posted, with seamless collection of content assets for future use.")]), _vm._v(" "), _c('li', [_vm._v("Direct access to reviewer contact information for the purpose of building relationships and facilitating additional collaborations.")])])])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://uat.app.getkobe.com/static/img/brand_sheet/ugc_process.png"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("INFLUENCER SELECTION")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Influencer selection is interest and response based. Based on what you complete within this form, the information will be distributed to 10,000 individuals with follower counts up to 3,000. The interested recipients will respond accordingly.You are not allowed to modify the requirements of creator quality, quantity, specification.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LOGISTICS ARRANGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-0"
  }, [_vm._v("For products")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('ul', [_c('li', [_vm._v("It is recommended for our clients to make your own logistics arrangements.")]), _vm._v(" "), _c('li', [_vm._v("For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.")]), _vm._v(" "), _c('li', [_vm._v("Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.")]), _vm._v(" "), _c('li', [_vm._v("There will be a 5 working day turnaround for all logistics arrangements.")]), _vm._v(" "), _c('li', [_vm._v("KOBE will not be responsible for any damaged or lost parcels.")])])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-0"
  }, [_vm._v("For experience")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('ul', [_c('li', [_vm._v("Creator attend the experience directly and client to verify")]), _vm._v(" "), _c('li', [_vm._v("Creator can make the purchase of experience with attached receipt for 100% reimbursement from client")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("UGC VIDEOS TRACKING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("You will receive email notification via your email address provided below each time a creator submits their content. The campaign concludes once the number of UGC videos achieves the number agreed.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("POST CAMPAIGN")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("You will have direct access to creator contact information for the purpose of relationship building, additional collaborations. Kobe will assume a non-interventionist role and will not levy any charges or engage in mediation with respect to the relationship. You are granted unrestricted discretion to communicate and negotiate according to your preferences.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetAOKFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.type !== 'custom') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    }) : _vm._e(), _vm._v(" "), (field.name === 'sampleVideoContent') ? _c('div', [(typeof _vm.brandSheet.sampleVideoContent === 'string') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.brandSheet.sampleVideoContent)
      }
    }) : _vm._e(), _vm._v(" "), (typeof _vm.brandSheet.sampleVideoContent === 'object') ? _c('v-row', {
      staticClass: "mb-3"
    }, _vm._l((_vm.brandSheet.sampleVideoContent), function(item, index) {
      return _c('v-col', {
        key: index,
        staticClass: "pb-0",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "12",
          "lg": "12",
          "align": "left"
        }
      }, [_c('a', {
        attrs: {
          "href": item.link,
          "target": "_blank"
        }
      }, [_vm._v("\n                              " + _vm._s(item.link) + "\n                            ")])])
    }), 1) : _vm._e(), _vm._v(" "), (_vm.brandSheet.sampleVideoContentFiles.length > 0) ? _c('div', [_c('v-row', _vm._l((_vm.brandSheet.sampleVideoContentFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "12",
          "lg": "12",
          "align": "left"
        }
      }, [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_vm._v("\n                                Click to View\n                              ")])])
    }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.name === 'marketingCollaterals') ? _c('div', [(typeof _vm.brandSheet.marketingURL === 'string') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.brandSheet.marketingURL)
      }
    }) : _vm._e(), _vm._v(" "), (typeof _vm.brandSheet.marketingURL === 'object') ? _c('v-row', {
      staticClass: "mb-3"
    }, _vm._l((_vm.brandSheet.marketingURL), function(item, index) {
      return _c('v-col', {
        key: index,
        staticClass: "pb-0",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "12",
          "lg": "12",
          "align": "left"
        }
      }, [_c('a', {
        attrs: {
          "href": item.link,
          "target": "_blank"
        }
      }, [_vm._v("\n                              " + _vm._s(item.link) + "\n                            ")])])
    }), 1) : _vm._e(), _vm._v(" "), (_vm.brandSheet.marketingCollaterals.length > 0) ? _c('div', [_c('v-row', _vm._l((_vm.brandSheet.marketingCollaterals), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('image') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        staticClass: "grey lighten-2",
        attrs: {
          "width": "67",
          "height": "85",
          "src": item.url,
          "lazy-src": item.url,
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e()])
    }), 1)], 1) : _vm._e()], 1) : _vm._e()])])
  }), 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d201134"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ViewBrandSheetModal.vue
// module id = 2023
// module chunks = 0